module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group-input"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.doesHaveError()
    }
  }, [_c('label', [_vm._t("default")], 2), _vm._v(" "), (!this.component) ? _c('input', {
    class: _vm.classNames,
    attrs: {
      "type": this.type,
      "placeholder": this.placeholder,
      "name": this.name
    },
    domProps: {
      "value": _vm.getState(_vm.$store)
    },
    on: {
      "input": _vm.updateQuote
    }
  }) : _vm._e(), _vm._v(" "), (_vm.checkComponentType('textarea')) ? _c('textarea', {
    class: _vm.classNames,
    attrs: {
      "data-rules": this.rules,
      "type": this.type,
      "placeholder": this.placeholder,
      "name": this.name
    },
    domProps: {
      "value": _vm.getState(_vm.$store)
    },
    on: {
      "input": _vm.updateQuote
    }
  }) : _vm._e(), _vm._v(" "), (_vm.checkComponentType('select')) ? _c('select', {
    class: _vm.classNames,
    attrs: {
      "data-rules": this.rules,
      "name": this.name
    },
    domProps: {
      "value": _vm.getState(_vm.$store)
    },
    on: {
      "input": _vm.updateQuote
    }
  }, [_vm._t("options")], 2) : _vm._e(), _vm._v(" "), (_vm.doesHaveError()) ? _c('p', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.renderError()))]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-547dbb53"}!./src/app/components/form-group-input/form-group-input.html
// module id = 482
// module chunks = 1